export default __webpack_public_path__ + "static/media/add-new.06184c02.svg";